import { OptionDto } from "../dtos/maintenance/option/OptionDto";
import { OptionsStripDto } from "../dtos/maintenance/option/OptionsStripDto";

export class NomsHardman {

    static buildOptionsSlot(): OptionsStripDto {
        let optionsSlots: OptionsStripDto = new OptionsStripDto();
        optionsSlots.add(OptionDto.build("NORMAL", "ADDRESS.DOCKS.PLANNING.NORMAL.PROMPT", "ADDRESS.DOCKS.PLANNING.NORMAL.HELP", "hardman-slots-times-1", 10, 0, 1, true, false))
        optionsSlots.add(OptionDto.build("DOCK", "ADDRESS.DOCKS.PLANNING.DOCK.PROMPT", "ADDRESS.DOCKS.PLANNING.DOCK.HELP", "hardman-slots-times-2", 20, 0, 1, false, false))
        optionsSlots.add(OptionDto.build("FORKLIFT", "ADDRESS.DOCKS.PLANNING.FORKLIFT.PROMPT", "ADDRESS.DOCKS.PLANNING.FORKLIFT.HELP", "hardman-slots-times-3", 30, 0, 1, false, false))

        return optionsSlots;
    }


    public static readonly NOTREADY = "routeNotReady";
    public static readonly PROBLEM = "routeWithProblem";
    public static readonly DELAYED = "routeDelayed";
    public static readonly URGENT = "routeUrgent";
    public static readonly plateBanned: string = "plateBanned";
    public static readonly phoneBanned: string = "phoneBanned";

}